import * as XLSX from "xlsx"

const contatosExportarXlsx = (aContatos) => {
  const aLinhas = Array.isArray(aContatos) ? aContatos : aContatos?.contacts ?? []
  const oPlanilha = XLSX.utils.json_to_sheet(aLinhas)
  const oLivro = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(oLivro, oPlanilha, "Contatos")
  XLSX.writeFile(oLivro, "contatos.xlsx")
}

export default contatosExportarXlsx
